var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TextCard", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass: "content-wrapper",
        attrs: { slot: "textCard__Text" },
        slot: "textCard__Text"
      },
      [
        _c(
          "v-row",
          { staticClass: "equal-height-row", attrs: { "no-gutters": "" } },
          [
            _c(
              "v-col",
              {
                staticClass: "left-section equal-height",
                attrs: { cols: "5" }
              },
              [_vm._t("left")],
              2
            ),
            _vm._v(" "),
            _c(
              "v-col",
              {
                staticClass: "right-section equal-height",
                attrs: { cols: "7" }
              },
              [_vm._t("right")],
              2
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e6e7a4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6e7a4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/components/SummaryCard.vue
// module id = null
// module chunks = 